export const returnSummary = async () => {
    const returnsSummaryContainer = document.querySelector('#returns-form-summary');
    const returnForm = document.querySelector('#returns-form');

    const formData = new FormData(returnForm);

    const response = await fetch('/api/issue/return_summary', {
        method: 'POST',
        body: new URLSearchParams(formData),
    });

    const html = await response.text();

    returnsSummaryContainer.innerHTML = html;
};
